import React from 'react';
import { Carousel } from 'react-bootstrap';

interface CarouselItem {
  src: string;
  alt: string;
  Title?: string;
  Description?: string;
}

interface ImageCarouselProps {
  items: CarouselItem[];
}

// {/* {items.map((item, index) => ( */}
// {items.slice(0, 4).map((item, index) => (
const Carousel_v06_basic: React.FC<ImageCarouselProps> = ({ items }) => {
  return (
    <Carousel fade interval={5000} pause="hover" className="w-100">
      {items.map((item, index) => (
      
        <Carousel.Item key={index}>
          <img
            className="d-block w-100 darken-img"
            src={item.src}
            alt={item.alt}
            style={{ objectFit: 'cover', height: '600px'}}
          />
          {(item.Title || item.Description) && (
            <Carousel.Caption>
              <h2>{item.Title}</h2>
              {/* <p style={{fontSize:'1.5em'}}>{item.Description}</p> */}

              <p className="carouselText">{item.Description}</p>
            </Carousel.Caption>
          )}
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

export default Carousel_v06_basic;
